export default "__VITE_ASSET__En_wP3WN__"